import {AString} from '@mintdata/mint-kit/api/values/AString';
import {AStringEnum} from '@mintdata/mint-kit/api/values/AStringEnum';

export class DeviceType extends AStringEnum
{
    public constructor(value:AString)
    {
        super(value, DeviceType.availableValues);
    }

    public toString():string
    {
        return this.value ? this.value.toString() : null;
    }

    public static DESKTOP = new AString('Desktop');
    public static TABLET = new AString('Tablet');
    public static MOBILE = new AString('Mobile');
    public static CUSTOM = new AString('Custom');

    public static availableValues:Array<AString> = [
        DeviceType.DESKTOP,
        DeviceType.TABLET,
        DeviceType.MOBILE,
        DeviceType.CUSTOM
    ];

    public static desktop():DeviceType
    {
        return new DeviceType(DeviceType.DESKTOP);
    }

    public static tablet():DeviceType
    {
        return new DeviceType(DeviceType.TABLET);
    }

    public static mobile():DeviceType
    {
        return new DeviceType(DeviceType.MOBILE);
    }

    public static custom():DeviceType
    {
        return new DeviceType(DeviceType.CUSTOM);
    }

    public static fromString(value:string):DeviceType
    {
        return new DeviceType(AString.fromString(value));
    }
}
